import Btnt from './BtnT';
import { SIZE } from './constants';

export default Btnt;
export { SIZE };